import React from 'react'
import styled from 'styled-components'
import { colors, spacing, mediaQuery } from 'src/constants/marketing-ds'

const Footer = () => {
  return (
    <FooterElement>
      <Content>
        <Logo
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Fubo_2023.svg/1200px-Fubo_2023.svg.png"
          alt="Fubo"
        />
        <Text>
          <p>&copy; 2025 FuboTV Inc. All rights reserved.</p>
          <p>We are committed to providing the best sports streaming experience.</p>
        </Text>
      </Content>
    </FooterElement>
  )
}

export default Footer

const FooterElement = styled.footer`
  border-top: 1px solid ${colors.slate[160]};
  background-color: #f8fafc;
  padding: ${spacing.xxxl} ${spacing.md};
`

const Content = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: ${spacing.md};

  ${mediaQuery.tablet} {
    flex-direction: row;
  }
`

const Logo = styled.img`
  height: 32px;
  width: auto;
  opacity: 0.5;
  filter: grayscale(100%);
`

const Text = styled.div`
  font-size: 14px;
  color: ${colors.slate[100]};
  text-align: center;

  ${mediaQuery.tablet} {
    text-align: right;
  }

  p {
    margin: 0;

    &:not(:first-child) {
      margin-top: 8px;
    }
  }
`

